import { Reveal } from "./Reveal";
import { Recycle, Factory, FlaskConical, ShieldCheck } from "lucide-react";

const caps = [
  {
    icon: Recycle,
    title: "Battery recycling",
    body: "Organised collection and safe breaking of spent lead-acid batteries, recovering lead, plastic and acid through a compliant channel.",
  },
  {
    icon: Factory,
    title: "Smelting",
    body: "Controlled furnace smelting of lead-bearing scrap with continuous emission capture and monitoring.",
  },
  {
    icon: FlaskConical,
    title: "Refining & alloying",
    body: "Kettle refining to 99.97%+ purity, plus antimonial and calcium lead alloys blended to exact customer chemistry.",
  },
  {
    icon: ShieldCheck,
    title: "Compliance & safety",
    body: "Fully compliant with GPCB and MoEF norms, with effluent treatment and worker-safety systems throughout the plant.",
  },
];

export const Services = () => (
  <section
    id="services"
    data-testid="services-section"
    className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40"
  >
    <Reveal>
      <div className="mb-14 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="mb-5 flex items-center gap-4 font-mono-tech text-xs uppercase tracking-[0.25em] text-[var(--mx-ink-2)]">
            <span className="h-px w-10 bg-[var(--mx-copper)]" />
            04 — Capabilities
          </div>
          <h2 className="max-w-2xl font-display text-5xl font-black uppercase leading-[0.9] tracking-tighter text-[var(--mx-ink)] md:text-7xl">
            From battery
            <br />
            to bullion
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-[var(--mx-ink-2)]">
          An end-to-end, closed-loop process — from collecting end-of-life
          batteries to casting refined lead and custom alloys.
        </p>
      </div>
    </Reveal>

    <div className="grid gap-5 md:grid-cols-2">
      {caps.map((c, i) => (
        <Reveal key={c.title} delay={i * 0.08}>
          <div className="group flex gap-6 rounded-2xl border border-[var(--mx-line)] bg-[var(--mx-surface)] p-8 transition-[transform,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-[0_24px_60px_-40px_rgba(27,23,20,0.4)] md:p-10">
            <div className="grid h-14 w-14 shrink-0 place-items-center rounded-xl bg-[var(--mx-copper)]/12 text-[var(--mx-copper)] transition-colors duration-500 group-hover:bg-[var(--mx-copper)] group-hover:text-white">
              <c.icon size={24} strokeWidth={1.6} />
            </div>
            <div>
              <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight text-[var(--mx-ink)]">
                {c.title}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-[var(--mx-ink-2)]">
                {c.body}
              </p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Services;
